import logoGov from '@/assets/img/govbr-colorido.png'
import styled from 'styled-components'

export const LogoGovBr = styled.img.attrs({
  src: logoGov,
})`
  width: 50px;
`
